import React, { createContext, useContext, useState } from 'react';

const GSTDisplayContext = createContext({
  gstMode: 'before',
  setGstMode: () => {},
});

export function GSTDisplayProvider({ children }) {
  const [gstMode, setGstMode] = useState('before');
  return (
    <GSTDisplayContext.Provider value={{ gstMode, setGstMode }}>
      {children}
    </GSTDisplayContext.Provider>
  );
}

export function useGSTDisplay() {
  return useContext(GSTDisplayContext);
}

export default GSTDisplayContext;
